import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  cuve: {},
};

export const cuveSlice = createSlice({
  name: "cuve",
  initialState,

  reducers: {
    setCuveData: (state, action) => {
      const { item, value, type = "CUVE", date } = action.payload || {};
      if (!item) return;
      if (Array.isArray(state.cuve)) state.cuve = {}; // 🛡️
      state.cuve[item] = { item, value, type, date };
    },

    setCuveSent: (state, action) => {
      state.cuveSent = action.payload;
    },

    clearCuve: (state) => {
      state.cuve = {};
    },
  },
});

// Action creators are generated for each case reducer function
export const { setCuveData, clearCuve, setCuveSent } = cuveSlice.actions;

export default cuveSlice.reducer;
